import React from 'react';
import { useIntl } from 'react-intl';

import { GoogleLogout } from '../google-login';

// eslint-disable-next-line react/prop-types
function Logout({ setUser }) {
  const intl = useIntl();

  const onSuccess = () => {
    setUser(null);
    // eslint-disable-next-line no-console
    console.log('Logout made successfully');
  };

  // eslint-disable-next-line no-undef
  return <GoogleLogout clientId={CLIENT_ID} buttonText={intl.messages.LOGOUT} onLogoutSuccess={onSuccess} />;
}

export default Logout;
